import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { DocsSelectDialog } from "@dash/select";
import { useTheme } from "@emotion/react";
import React, { useState } from "react";
import { MdCheck } from "react-icons/md";

import { Report } from "@megaron/analytics-contracts";
import { useClientManager } from "@megaron/react-clients";
import { ResourceId } from "@megaron/resource";

export const ReportAssigneesDialog: React.FC<{ report: Report; onClose: () => void }> = ({ report, onClose }) => {
  const theme = useTheme();
  const [assignees, setAssignees] = useState(report.assignees);

  const save = useClientManager("analytics")
    .saveReport()
    .useMutation({
      onSuccess: async (_, __, { queryClient }) => {
        await queryClient.invalidateQueries(["analytics"]);
        onClose();
      },
    });

  return (
    <Dialog onClose={onClose} header="Dostęp do raportu" placement="center" css={{ width: "500px", height: "auto" }}>
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "2px" }}>
        <span css={{ fontSize: "0.875rem", color: theme.colors.secondaryText }}>
          Przypisane osoby mogą wyświetlać i przeliczać raport, ale nie mogą go edytować. Muszą mieć rolę
          analytics.report-reader.
        </span>
        <DocsSelectDialog
          label="Osoby"
          initiallySelectedDocIds={report.assignees.map((id) => ResourceId("user", id))}
          onSelectedChange={(options) => setAssignees(options.map((option) => option.value))}
          docType={["user"]}
          variant="multi-select"
        />
        {save.isError && (
          <span css={{ fontSize: "0.75rem", color: theme.colors.danger }}>Nie udało się zapisać dostępu</span>
        )}
        <Button
          icon={<MdCheck />}
          css={{ alignSelf: "flex-end" }}
          onClick={() => save.mutate({ ...report, assignees })}
          isLoading={save.isLoading}
        >
          Zapisz
        </Button>
      </div>
    </Dialog>
  );
};
